<template>
  <div :class="{ 'form-fullScreen': isEdit && !isEditInDialog }">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <div class="filter-box">
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            v-if="isShowAdd"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
        </div>
      </div>
      <TableList
        v-loading="listLoading"
        :dataList="list"
        :total="total"
        :columnAllData="columnAllData"
        :page="listQuery.page"
        :size="listQuery.size"
        :showSelection="false"
        :canRefresh="false"
        :canChangeColumn="false"
        :isShowPagination="false"
        :tableName="TableName"
        :permissionName="permissionName"
        :showSummary="true"
        @command-change="handleCommand"
      >
       <template v-slot:operation-action="scope">
          <el-link
            v-permission="{ pkey: `${permissionName}_EDIT` }"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('edit', scope.row)"
          >
            {{ t("table.edit") }}
          </el-link>
          <el-link
            v-permission="{ pkey: `${permissionName}_DELETE` }"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('delete', scope.row)"
          >
            删除
          </el-link>
        </template>
      </TableList>
    </div>
    <template v-if="dialogFormVisible && !isEditInDialog">
      <FormComponent
        v-if="!activeId"
        :id="activeId"
        :initFormData="initFormData"
        :fromFieldData="fromFieldData"
        :dialogFormVisible="dialogFormVisible"
        :api="addPathApi"
        :handleResolveTempData="handleResolveTempData"
        @update:visibel="dialogFormVisible = false;isEdit = false"
        @submit="handleSubmit(formData);isEdit = false"
      >
        <template v-slot:front>
          <MateriallDescription :detail="materialInfo"/>
        </template>
      </FormComponent>
      <FormComponent
        v-else
        :id="activeId"
        :initFormData="initEditFromData"
        :fromFieldData="editFromData"
        :dialogFormVisible="dialogFormVisible"
        :api="editPathPai"
        method="PUT"
        @update:visibel="dialogFormVisible = false;isEdit = false"
        @submit="handleSubmit(formData);isEdit = false"
      >
        <template v-slot:front>
          <MateriallDescription :detail="materialInfo"/>
        </template>
      </FormComponent>
    </template>
    <template v-if="isEditInDialog">
      <el-dialog
        v-model="dialogFormVisible"
        title="编辑价格信息"
        width="80%"
        append-to-body
        :close-on-click-modal="false"
      >
        <FormComponent
          :id="activeId"
          :initFormData="initEditFromData"
          :fromFieldData="editFromData"
          :dialogFormVisible="dialogFormVisible"
          :api="editPathPai"
          method="PUT"
          @update:visibel="dialogFormVisible = false;isEdit = false"
          @submit="handleSubmit(formData);isEdit = false"
        >
          <template v-slot:front>
            <MateriallDescription :detail="materialInfo"/>
          </template>
        </FormComponent>
      </el-dialog>
    </template>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { cloneDeep } from 'lodash'
import { deleteById, getDetailById } from '@/apis/Dictionary'
import { getDropdownByType } from '@/apis/tool'
import { getPageList as getUrlList } from '@/apis/Form'

import { PaymentCycleModel } from '@/model/Index'

import FormComponent from '@/components/Form/index.vue'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from './FieldFrom'
import { editFromData } from './EditFieldFrom'
import { supplierTableField, materialTableField } from './FieldTable'
import { pageVo } from '@/utils/index'
import MateriallDescription from '@/views/purchasManage/materialInfo/MateriallDescription.vue'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Priceinfo',
  components: {
    FormComponent,
    TableList,
    MateriallDescription
  },
  props: {
    id: { type: Number, required: true, default: 0 },
    dataId: { type: Number, required: true, default: 0 },
    formPage: { type: String, required: true, default: 'material' },
    isShowAdd: { type: Boolean, required: false, default: true },
    isEditInDialog: { type: Boolean, required: false, default: false },
    materialInfo: { type: Object, required: false, default: {} as any }
  },
  setup(props) {
    const { t } = useI18n()

    const dataMap = reactive({
      TableName: props.formPage !== 'material' ? TableName.TABLE_SUPPLIER_PRICE_INFO : TableName.TABLE_MATERIAL_PRICE_INFO,
      permissionName: permissionName.MATERIAL_PRICE_INFO,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: FromFieldData,
      editFromData: cloneDeep(editFromData),
      initEditFromData: cloneDeep(editFromData),
      columnAllData: props.formPage !== 'material' ? materialTableField : supplierTableField,
      // addPathApi: `material/${props.id}/actions/inquiries`,
      addPathApi: 'materialInquiry',
      editPathPai: 'materialInquiry',
      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        ...pageVo
      },
      dialogFormVisible: false,
      isEdit: false,
      materialInfo: props.materialInfo,

      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            dataMap.isEdit = true
            break
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      getList() {
        if (!props.id) {
          return
        }
        dataMap.materialInfo = props.materialInfo
        dataMap.listLoading = true
        getUrlList(`${props.formPage}/${props.id}/actions/inquiries`).then((res: any) => {
          dataMap.list = res
            ? res.map((item: any) => {
              const temp = item
              if (item.material) {
                Object.assign(temp, {
                  materialNo: item.material.no,
                  materialClass: item.material.materialClass,
                  materialUnit: item.material.materialUnit,
                  materialId: item.material.id,
                  materialBrand: item.material.brand,
                  materialName: item.material.name,
                  materialModel: item.material.model,
                  materialCode: item.material.code,
                  materialParameter: item.material.parameter,
                  materialDevice: item.material.device
                })
              }
              if (item.supplier) {
                const { supplier } = item
                Object.assign(temp, {
                  supplierId: supplier.id,
                  supplierName: supplier.name,
                  supplierMainBusiness: supplier.mainBusiness,
                  supplierWebsite: supplier.Website,
                  supplierContactNumber: supplier.contactNumber,
                  supplierMail: supplier.mail,
                  supplierAddress: supplier.address,
                  supplierAddressDetail: supplier.addressDetail,
                  supplierMark: supplier.mark,
                  supplierTitleName: supplier.titleName,
                  supplierTaxId: supplier.taxId,
                  supplierRegisteredAddress: supplier.registeredAddress,
                  supplierBank: supplier.bank,
                  supplierAccount: supplier.account,
                  supplierPhone: supplier.phone
                })
              }
              return temp
            })
            : []
          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.initFormData.forEach((k: any) => {
          k.formList.forEach((formList: any) => {
            formList.list.forEach((field: any) => {
              if (field.fieldKey === 'materialId') {
                field.value = props.id
              }
            })
          })
        })
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.editFromData = cloneDeep(dataMap.initEditFromData)
        getDetailById(dataMap.editPathPai, row.id).then((res: any) => {
          dataMap.editFromData.forEach((k: any) => {
            k.formList.forEach(async(field: any) => {
              field.value = row[field.fieldKey]
              if (field.fieldKey === 'containsRate') {
                field.value = res[field.fieldKey]
              }
              this.handleOption(field)
            })
          })
          dataMap.dialogFormVisible = true
          dataMap.isEdit = true
        })
      },
      async handleOption(field: any) {
        switch (field.fieldKey) {
          case 'materialId':
            if (props.formPage === 'material') {
              const result = await getUrlList(`material/${props.id}`)
              field.value = result.id
              field.option = [{
                id: result.id,
                name: result.name
              }]
            }
            break
          case 'supplier':
            if (props.formPage === 'supplier') {
              const result = await getUrlList(`supplier/${props.id}`)
              field.value = result.id
              field.option = [{
                id: result.id,
                name: result.name
              }]
            }
            break
        }
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById(dataMap.editPathPai, row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleResolveTempData(tempModel: any) {
        console.log(tempModel, 'tempModel')
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      loadTableSelectOption() {
        dataMap.columnAllData.forEach((column: any) => {
          if (column.selectType === 1 && column.url) {
            getDropdownByType(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          }
        })
      }
    })
    watch(() => props.dataId, () => {
      dataMap.getList()
    })
    onMounted(() => {
      dataMap.loadTableSelectOption()
      dataMap.getList()
    })
    return { t, ...toRefs(dataMap) }
  }
})
</script>
